(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rc-product-actions"] && !Shopify.designMode) return;
  try {
    (function () {
    function selectedQty() {
      var card = document.querySelector('[data-rc-qty] .rc-qty__card.is-selected');
      return card ? parseInt(card.getAttribute('data-qty'), 10) || 1 : 1;
    }

    function updateWhatsApp() {
      document.querySelectorAll('[data-rc-actions]').forEach(function (root) {
        var text = root.getAttribute('data-wa-message') + ' ' + root.getAttribute('data-product-title') + ' - ' + selectedQty() + ' buc.';
        root.querySelectorAll('[data-rc-wa-link]').forEach(function (link) {
          link.href = 'https://wa.me/' + root.getAttribute('data-wa') + '?text=' + encodeURIComponent(text);
        });
      });
    }

    function revealQuickOrder() {
      var hasEasySell = !!document.querySelector('.es-popup-button-product');
      document.querySelectorAll('[data-rc-quick-order]').forEach(function (button) {
        button.hidden = !hasEasySell;
      });
      return hasEasySell;
    }

    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      if (event.target.closest('.rc-qty__card')) setTimeout(updateWhatsApp, 0);

      var quick = event.target.closest('[data-rc-quick-order]');
      if (!quick) return;
      var esButton = document.querySelector('.es-popup-button-product');
      if (esButton) esButton.click();
    });

    document.addEventListener('DOMContentLoaded', function () {
      updateWhatsApp();
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (revealQuickOrder() || tries > 50) clearInterval(timer);
      }, 200);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rc-product-head"] && !Shopify.designMode) return;
  try {
    (function () {
    function initGallery(g) {
      if (g.dataset.rcGallery) return;
      var container = g.querySelector('slideshow-container');
      var slides = g.querySelectorAll('slideshow-slide');
      if (!container || slides.length < 2) return;
      g.dataset.rcGallery = '1';

      var thumbs = g.querySelector('.slideshow-controls__thumbnails-container');
      if (!thumbs) return;
      var prev = document.createElement('button');
      var next = document.createElement('button');
      prev.type = next.type = 'button';
      prev.className = 'rc-thumbs-arrow rc-thumbs-arrow--prev';
      next.className = 'rc-thumbs-arrow rc-thumbs-arrow--next';
      prev.setAttribute('aria-label', 'Înapoi');
      next.setAttribute('aria-label', 'Înainte');
      prev.innerHTML = '<i class="fa-solid fa-chevron-left" aria-hidden="true"></i>';
      next.innerHTML = '<i class="fa-solid fa-chevron-right" aria-hidden="true"></i>';
      thumbs.appendChild(prev);
      thumbs.appendChild(next);

      function updateArrows() {
        var overflow = thumbs.scrollWidth > thumbs.clientWidth + 2;
        prev.classList.toggle('is-on', overflow && thumbs.scrollLeft > 2);
        next.classList.toggle('is-on', overflow && thumbs.scrollLeft + thumbs.clientWidth < thumbs.scrollWidth - 2);
      }
      prev.addEventListener('click', function () { thumbs.scrollBy({ left: -thumbs.clientWidth * 0.7, behavior: 'smooth' }); });
      next.addEventListener('click', function () { thumbs.scrollBy({ left: thumbs.clientWidth * 0.7, behavior: 'smooth' }); });
      thumbs.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    function run() {
      if (!document.querySelector('[data-rc-pdp]')) return;
      document.querySelectorAll('.product-information media-gallery').forEach(initGallery);
    }

    document.addEventListener('DOMContentLoaded', run);
    window.addEventListener('load', run);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rc-product-offers"] && !Shopify.designMode) return;
  try {
    /* Keep RoyalCare blocks (price, SKU, offers, variant cards) in sync when the theme swaps variants.
     Lives here (not in rc-product-price) because this block is present in every product template. */
  document.addEventListener(
    'shopify:product:select',
    function (event) {
      var section = event.target && event.target.closest ? event.target.closest('.shopify-section') : null;
      if (!section || !event.promise) return;
      event.promise.then(function (result) {
        var html = result && result.detail && result.detail.html;
        if (!html) return;
        section.querySelectorAll('[data-rc-live]').forEach(function (el) {
          var fresh = html.querySelector('[data-rc-live="' + el.getAttribute('data-rc-live') + '"]');
          if (fresh) el.innerHTML = fresh.innerHTML;
        });
      }).catch(function () {});
    },
    true
  );

  /* ---------- Quantity offer cards (variants = quantities) ---------- */
  document.addEventListener('click', function (event) {
    var card = event.target.closest ? event.target.closest('.rc-offer') : null;
    if (!card || card.disabled) return;
    var section = card.closest('.shopify-section');
    if (!section) return;
    var value = card.getAttribute('data-rc-offer-value');
    var inputs = section.querySelectorAll('variant-picker fieldset input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === value) {
        inputs[i].click();
        break;
      }
    }
    card.parentElement.querySelectorAll('.rc-offer').forEach(function (c) {
      var on = c === card;
      c.classList.toggle('rc-offer--selected', on);
      c.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  });

  /* ---------- Shade picker: one row per piece, mixed shades added as separate cart lines ---------- */
  (function () {
    var MAX_ROWS = 5;

    function rowsOf(root) { return root.querySelectorAll('[data-rc-vpick-row]'); }

    function selectInRow(row, value) {
      row.querySelectorAll('.rc-vpick__card').forEach(function (c) {
        var on = c.getAttribute('data-rc-vpick-value') === value;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var label = row.querySelector('[data-rc-vpick-current]');
      if (label) label.textContent = value;
    }

    function selectedOf(row) {
      var c = row.querySelector('.rc-vpick__card.is-selected');
      return c ? { id: c.getAttribute('data-variant-id'), value: c.getAttribute('data-rc-vpick-value') } : null;
    }

    function qtyOf(root) {
      var scope = root.closest('.product-information') || root.closest('.shopify-section') || document;
      var card = scope.querySelector('.rc-qty__card.is-selected');
      if (card) return parseInt(card.getAttribute('data-qty'), 10) || 1;
      var input = scope.querySelector('input[name="quantity"]');
      return (input && parseInt(input.value, 10)) || 1;
    }

    function layout(root) {
      var n = Math.max(1, Math.min(qtyOf(root), MAX_ROWS));
      var first = root.querySelector('[data-rc-vpick-row]');
      var extra = root.querySelector('[data-rc-vpick-extra]');
      var start = selectedOf(first);
      var current = extra.querySelectorAll('[data-rc-vpick-row]');
      for (var i = current.length + 1; i < n; i++) {
        var clone = first.cloneNode(true);
        extra.appendChild(clone);
        if (start) selectInRow(clone, start.value);
      }
      current = extra.querySelectorAll('[data-rc-vpick-row]');
      for (var j = current.length; j > n - 1; j--) current[j - 1].remove();
      root.classList.toggle('is-multi', n > 1);
      rowsOf(root).forEach(function (row, index) {
        var prefix = row.querySelector('[data-rc-vpick-prefix]');
        if (prefix) prefix.textContent = n > 1 ? 'Produsul ' + (index + 1) : root.getAttribute('data-option');
      });
      hideMsg(root);
    }

    function counts(root) {
      var map = {};
      rowsOf(root).forEach(function (row) {
        var s = selectedOf(row);
        if (s) map[s.id] = (map[s.id] || 0) + 1;
      });
      return map;
    }

    function isMixed(root) { return Object.keys(counts(root)).length > 1; }

    function variantIds(root) {
      return Array.prototype.map.call(root.querySelector('[data-rc-vpick-row]').querySelectorAll('.rc-vpick__card'), function (c) {
        return c.getAttribute('data-variant-id');
      });
    }

    function showMsg(root, text) {
      var msg = root.querySelector('[data-rc-vpick-msg]');
      if (!msg) return;
      msg.textContent = text;
      msg.hidden = false;
    }

    function hideMsg(root) {
      var msg = root.querySelector('[data-rc-vpick-msg]');
      if (msg) msg.hidden = true;
    }

    function init() {
      document.querySelectorAll('[data-rc-vpick]').forEach(function (root) {
        if (root.dataset.rcReady) return;
        root.dataset.rcReady = '1';
        var first = root.querySelector('[data-rc-vpick-row]');
        var currentId = root.getAttribute('data-current');
        var card = first.querySelector('.rc-vpick__card[data-variant-id="' + currentId + '"]') || first.querySelector('.rc-vpick__card:not([disabled])');
        if (card) selectInRow(first, card.getAttribute('data-rc-vpick-value'));
        layout(root);
      });
    }

    document.addEventListener('DOMContentLoaded', init);
    window.addEventListener('pageshow', init);
    if (document.readyState !== 'loading') init();

    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;

      /* a shade card */
      var card = event.target.closest('.rc-vpick__card');
      if (card && !card.disabled) {
        var root = card.closest('[data-rc-vpick]');
        var row = card.closest('[data-rc-vpick-row]');
        var value = card.getAttribute('data-rc-vpick-value');
        selectInRow(row, value);
        hideMsg(root);
        if (row === root.querySelector('[data-rc-vpick-row]')) {
          var section = root.closest('.shopify-section') || document;
          var inputs = section.querySelectorAll('variant-picker fieldset input[type="radio"]');
          for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].value === value) {
              if (!inputs[i].checked) inputs[i].click();
              break;
            }
          }
        }
        return;
      }

      /* the quantity cards ("1 / 2 / 3 bucăți") change the number of rows */
      if (event.target.closest('.rc-qty__card')) {
        setTimeout(function () { document.querySelectorAll('[data-rc-vpick]').forEach(layout); }, 0);
      }
    });

    /* "Adaugă în coș" with mixed shades: add each shade as its own cart line. */
    document.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest ? event.target.closest('.add-to-cart-button') : null;
        if (!button) return;
        var root = document.querySelector('[data-rc-vpick].is-multi');
        if (!root || !isMixed(root)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (button.dataset.rcBusy) return;
        button.dataset.rcBusy = '1';
        var map = counts(root);
        var items = Object.keys(map).map(function (id) { return { id: Number(id), quantity: map[id] }; });
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res && res.status) {
              showMsg(root, res.description || res.message || 'Nu am putut adăuga produsele în coș.');
              return null;
            }
            return fetch('/?sections=cart-drawer-section')
              .then(function (r) { return r.json(); })
              .then(function (sections) {
                return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
                  var events = window.RoyalCareCartEvents;
                  if (!events || !events.CartLinesUpdateEvent) {
                    window.location.href = '/cart';
                    return;
                  }
                  var deferred = events.CartLinesUpdateEvent.createPromise();
                  root.dispatchEvent(
                    new events.CartLinesUpdateEvent({
                      action: 'add',
                      context: 'product',
                      lines: items.map(function (i) { return { merchandiseId: String(i.id), quantity: i.quantity }; }),
                      promise: deferred.promise
                    })
                  );
                  deferred.resolve({
                    cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
                    detail: { sections: sections, source: 'rc-vpick', itemCount: cart.item_count, didError: false }
                  });
                });
              });
          })
          .catch(function () { showMsg(root, 'Nu am putut adăuga produsele în coș. Încearcă din nou.'); })
          .then(function () { delete button.dataset.rcBusy; });
      },
      true
    );

    /* EasySell quick order sets the cart quantity of the selected variant (cart/update.js):
       with mixed shades, set each shade's own quantity instead, so the COD form shows and sends the real mix. */
    if (!window.__rcVpickFetch) {
      window.__rcVpickFetch = true;
      var originalFetch = window.fetch;
      window.fetch = function (input, init) {
        try {
          var url = String((input && input.url) || input);
          if (/\/cart\/update\.js/.test(url) && init && typeof init.body === 'string') {
            var root = document.querySelector('[data-rc-vpick].is-multi');
            if (root && isMixed(root)) {
              var body = JSON.parse(init.body);
              var keys = Object.keys(body.updates || {});
              var ids = variantIds(root);
              if (keys.length === 1 && ids.indexOf(String(keys[0])) > -1 && Number(body.updates[keys[0]]) === rowsOf(root).length) {
                var map = counts(root);
                var updates = {};
                ids.forEach(function (id) { updates[id] = map[id] || 0; });
                body.updates = updates;
                init = Object.assign({}, init, { body: JSON.stringify(body) });
              }
            }
          }
        } catch (e) {}
        return originalFetch.call(this, input, init);
      };
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rc-product-qty"] && !Shopify.designMode) return;
  try {
    (function () {
    function setQty(root, card) {
      var qty = parseInt(card.getAttribute('data-qty'), 10) || 1;
      root.querySelectorAll('.rc-qty__card').forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var section = root.closest('.shopify-section') || document;
      var input = section.querySelector('.product-information input[name="quantity"]') || section.querySelector('input[name="quantity"]');
      if (!input) return;
      input.value = qty;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      renderPanel(root);
      renderHint(root);
      updateAtcPrice(root);
    }

    /* Show the selected total inside "Adaugă în coș". */
    function updateAtcPrice(root) {
      var card = root.querySelector('.rc-qty__card.is-selected');
      if (!card) return;
      var price = parseInt(card.getAttribute('data-price'), 10);
      if (!price) return;
      var scope = root.closest('.product-information') || root.closest('.shopify-section') || document;
      var button = scope.querySelector('.add-to-cart-button:not(.sticky-add-to-cart__button)');
      if (!button) return;
      var tag = button.querySelector('[data-rc-atc-price]');
      if (!tag) {
        tag = document.createElement('span');
        tag.className = 'rc-atc-price';
        tag.setAttribute('data-rc-atc-price', '');
        var added = button.querySelector('.add-to-cart__added');
        button.insertBefore(tag, added || null);
      }
      var lei = price / 100;
      tag.textContent = '· ' + (Number.isInteger(lei) ? String(lei) : lei.toFixed(2).replace('.', ',')) + ' Lei';
    }

    /* Design B: words for the perks of the selected tile + a nudge to the next one. */
    function perksOf(card) {
      var gift = card.querySelector('[data-rc-perk="gift"]');
      var ship = card.querySelector('[data-rc-perk="ship"]');
      return { gift: !!(gift && !gift.hidden), ship: !!(ship && !ship.hidden) };
    }

    function renderHint(root) {
      var hint = root.querySelector('[data-rc-hint]');
      if (!hint) return;
      var cards = Array.prototype.slice.call(root.querySelectorAll('.rc-qty__card'));
      var selected = root.querySelector('.rc-qty__card.is-selected') || cards[0];
      if (!selected) return;
      var giftIcon = '<i class="fa-solid fa-gift" aria-hidden="true"></i>';
      var shipIcon = '<i class="fa-solid fa-truck-fast" aria-hidden="true"></i>';
      var label = function (card) {
        var n = parseInt(card.getAttribute('data-qty'), 10) || 1;
        return n + ' ' + (n === 1 ? (root.dataset.unitOne || 'bucată') : (root.dataset.unitMany || 'bucăți'));
      };
      var have = perksOf(selected);
      var later = cards.slice(cards.indexOf(selected) + 1);
      var nextGift = !have.gift ? later.find(function (c) { return perksOf(c).gift; }) : null;
      var nextShip = !have.ship ? later.find(function (c) { return perksOf(c).ship; }) : null;
      var parts = [];

      if (have.gift && have.ship) {
        parts.push('<span>' + giftIcon + '<b>Cadou surpriză</b> + ' + shipIcon + '<b>Transport gratuit</b> incluse!</span>');
      } else {
        if (have.gift) parts.push('<span>' + giftIcon + '<b>Cadou surpriză inclus</b></span>');
        if (have.ship) parts.push('<span>' + shipIcon + '<b>Transport gratuit inclus</b></span>');
        if (nextGift && nextShip && nextGift === nextShip) {
          parts.push('<span>Alege <b>' + label(nextGift) + '</b> și primești ' + giftIcon + '<b>cadou surpriză</b> + ' + shipIcon + '<b>transport gratuit</b></span>');
        } else {
          if (nextGift) parts.push('<span>Alege <b>' + label(nextGift) + '</b> și primești ' + giftIcon + '<b>cadou surpriză</b></span>');
          if (nextShip) parts.push('<span>Alege <b>' + label(nextShip) + '</b> pentru ' + shipIcon + '<b>transport gratuit</b></span>');
        }
      }

      hint.classList.toggle('is-complete', have.gift && have.ship);
      hint.innerHTML = parts.join('');
      hint.hidden = parts.length === 0;
    }

    /* Design C: one summary panel for the selected quantity. */
    function renderPanel(root) {
      var panel = root.querySelector('[data-rc-panel]');
      if (!panel) return;
      var card = root.querySelector('.rc-qty__card.is-selected') || root.querySelector('.rc-qty__card');
      if (!card) return;
      var qty = parseInt(card.getAttribute('data-qty'), 10) || 1;
      var price = parseInt(card.getAttribute('data-price'), 10) || 0;
      var reference = parseInt(card.getAttribute('data-reference'), 10) || price;
      var full = parseInt(card.getAttribute('data-full'), 10) || price;
      var money = function (cents) {
        var lei = cents / 100;
        return (Number.isInteger(lei) ? String(lei) : lei.toFixed(2).replace('.', ',')) + ' lei';
      };
      var perks = [];
      var gift = card.querySelector('[data-rc-perk="gift"]');
      var ship = card.querySelector('[data-rc-perk="ship"]');
      if (gift && !gift.hidden) perks.push('<li><i class="fa-solid fa-gift" aria-hidden="true"></i>Cadou surpriză inclus</li>');
      if (ship && !ship.hidden) perks.push('<li><i class="fa-solid fa-truck-fast" aria-hidden="true"></i>Transport gratuit</li>');
      var meta = [];
      if (price < full) meta.push('<span class="rc-qty__panel-unit">' + money(Math.round(price / qty)) + ' / ' + (root.dataset.unitShort || 'buc.') + '</span>');
      if (reference > price) meta.push('<span class="rc-qty__panel-save">Economisești ' + money(reference - price) + '</span>');
      panel.innerHTML =
        '<div class="rc-qty__panel-main">' +
          '<span class="rc-qty__panel-label">Total pentru ' + qty + ' ' + (qty === 1 ? (root.dataset.unitOne || 'bucată') : (root.dataset.unitMany || 'bucăți')) + '</span>' +
          '<span class="rc-qty__panel-price">' + money(price) +
            (reference > price ? ' <s>' + money(reference) + '</s>' : '') +
          '</span>' +
          (meta.length ? '<span class="rc-qty__panel-meta">' + meta.join('') + '</span>' : '') +
        '</div>' +
        (perks.length ? '<ul class="rc-qty__panel-perks">' + perks.join('') + '</ul>' : '');
    }

    document.addEventListener('click', function (event) {
      var card = event.target.closest ? event.target.closest('.rc-qty__card') : null;
      if (!card) return;
      var root = card.closest('[data-rc-qty]');
      if (root) setQty(root, card);
    });

    function init() {
      document.querySelectorAll('[data-rc-qty]').forEach(function (root) {
        var selected = root.querySelector('.rc-qty__card.is-selected');
        if (selected) setQty(root, selected);
      });
    }

    document.addEventListener('DOMContentLoaded', init);
    window.addEventListener('pageshow', init);

    /* Prices from EasySell quantity offers (rendered hidden inside the EasySell form). */
    function parseMoney(text) {
      var clean = (text || '').replace(/[^0-9,.]/g, '');
      if (clean.indexOf(',') > -1) clean = clean.replace(/\./g, '').replace(',', '.');
      var value = parseFloat(clean);
      return isNaN(value) ? null : Math.round(value * 100);
    }

    function formatMoney(cents) {
      var lei = cents / 100;
      var text = Number.isInteger(lei) ? String(lei) : lei.toFixed(2).replace('.', ',');
      return text + ' lei';
    }

    function applyEasySellPrices() {
      var offers = document.querySelectorAll('.es-modal .es-quantity-offers .es-qo-container');
      if (!offers.length) return false;
      document.querySelectorAll('[data-rc-qty][data-easysell]').forEach(function (root) {
        setTimeout(function () { renderPanel(root); renderHint(root); updateAtcPrice(root); }, 0);
        var gift = parseInt(root.getAttribute('data-gift'), 10) || 0;
        var ship = parseInt(root.getAttribute('data-ship'), 10) || 0;
        root.querySelectorAll('.rc-qty__card').forEach(function (card) {
          var qty = parseInt(card.getAttribute('data-qty'), 10) || 1;
          var offer = offers[qty - 1];
          if (!offer) return;
          var priceEl = offer.querySelector('.es-o-p');
          var price = priceEl ? parseMoney(priceEl.textContent) : null;
          if (!price) return;
          var reference = parseInt(card.getAttribute('data-reference'), 10) || price;
          card.querySelector('[data-rc-price]').textContent = formatMoney(price);
          var was = card.querySelector('[data-rc-was]');
          was.textContent = formatMoney(reference);
          was.hidden = price >= reference;
          var hasGift = gift > 0 && price >= gift;
          var hasShip = ship > 0 && price >= ship;
          card.querySelector('[data-rc-perk="gift"]').hidden = !hasGift;
          card.querySelector('[data-rc-perk="ship"]').hidden = !hasShip;
          card.querySelector('[data-rc-perks]').hidden = !(hasGift || hasShip);
          card.setAttribute('data-price', price);
          var full = parseInt(card.getAttribute('data-full'), 10) || price;
          var unit = card.querySelector('[data-rc-unit]');
          unit.textContent = formatMoney(Math.round(price / qty)) + ' / ' + (root.dataset.unitShort || 'buc.');
          unit.hidden = !(price < full);
        });
      });
      return true;
    }

    function waitForEasySell() {
      if (!document.querySelector('[data-rc-qty][data-easysell]')) return;
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (applyEasySellPrices() || tries > 50) clearInterval(timer);
      }, 200);
    }

    document.addEventListener('DOMContentLoaded', waitForEasySell);

    /* EasySell's product quick order replaces the whole Shopify cart with this product.
       Keep a snapshot of the visitor's cart and put it back when the form is closed without leaving the page. */
    var cartSnapshot = null;

    function refreshSnapshot() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          cartSnapshot = cart.items.map(function (item) {
            return { id: item.variant_id, quantity: item.quantity, properties: item.properties || {} };
          });
        })
        .catch(function () {});
    }

    function esModalOpen() {
      return Array.prototype.some.call(document.querySelectorAll('.es-modal'), function (modal) {
        return getComputedStyle(modal).display !== 'none';
      });
    }

    function restoreCart(items) {
      return fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
        .then(function () {
          if (!items.length) return null;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function () { return fetch('/?sections=cart-drawer-section'); })
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var events = window.RoyalCareCartEvents;
            if (!events || !events.CartLinesUpdateEvent) return;
            var deferred = events.CartLinesUpdateEvent.createPromise();
            document.dispatchEvent(
              new events.CartLinesUpdateEvent({
                action: 'update',
                context: 'standard-action',
                lines: [{ id: 'rc-restore', quantity: 0 }],
                promise: deferred.promise
              })
            );
            deferred.resolve({
              cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: { sections: sections, source: 'rc-cart-restore', itemCount: cart.item_count }
            });
          });
        })
        .catch(function () {});
    }

    function guardCart() {
      if (!cartSnapshot) return;
      var saved = cartSnapshot.slice();
      var seenOpen = false;
      var ticks = 0;
      var watcher = setInterval(function () {
        ticks += 1;
        var open = esModalOpen();
        if (open) seenOpen = true;
        if (seenOpen && !open) {
          clearInterval(watcher);
          restoreCart(saved).then(refreshSnapshot);
        } else if (!seenOpen && ticks > 40) {
          clearInterval(watcher);
        }
      }, 300);
    }

    document.addEventListener('DOMContentLoaded', function () {
      if (document.querySelector('[data-rc-qty]')) refreshSnapshot();
    });

    document.addEventListener('shopify:cart:lines-update', function (event) {
      if (event.detail && event.detail.source === 'rc-cart-restore') return;
      if (event.promise) event.promise.then(refreshSnapshot, function () {});
    });

    document.addEventListener(
      'click',
      function (event) {
        if (event.target.closest && event.target.closest('.es-popup-button-product, #es-sticky')) guardCart();
      },
      true
    );

    /* EasySell quick order: open the COD form with the same quantity offer the visitor picked here. */
    document.addEventListener(
      'click',
      function (event) {
        var esButton = event.target.closest ? event.target.closest('.es-popup-button-product, #es-sticky') : null;
        if (!esButton) return;
        var selected = document.querySelector('[data-rc-qty] .rc-qty__card.is-selected');
        var qty = selected ? parseInt(selected.getAttribute('data-qty'), 10) || 1 : 1;
        var tries = 0;
        var timer = setInterval(function () {
          tries += 1;
          var offers = document.querySelectorAll('.es-modal .es-quantity-offers .es-qo-container');
          var target = offers[qty - 1];
          if (target) {
            if (target.getAttribute('offer-selected') !== 'true') target.click();
            clearInterval(timer);
          } else if (tries > 30) {
            clearInterval(timer);
          }
        }, 100);
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
